<div class="date-filter-container mb-0">
    <div class="date-filter-header">
        <div class="date-nav-with-label">
            <button type="button" class="btn date-nav-btn" (click)="decrementDate()" rippleEffect>
                <i data-feather="chevron-left"></i>
            </button>
            <button type="button" class="btn date-nav-btn" (click)="incrementDate()" rippleEffect>
                <i data-feather="chevron-right"></i>
            </button>
            <p class="date-display">{{ selectedPeriod || '' }}</p>
        </div>
    </div>
    <div class="date-filter-buttons">
        <div class="btn-group" role="group">
            <button type="button" class="btn bouttons" rippleEffect (click)="changeViewMode('jours');"
                    [class.active]="viewMode==='jours'">
                <p>Jours</p>
            </button>
            <button type="button" class="btn bouttons" rippleEffect (click)="changeViewMode('mois');"
                    [class.active]="viewMode==='mois'">
                <p>Mois</p>
            </button>
            <button type="button" class="btn bouttons" rippleEffect (click)="changeViewMode('annees');"
                    [class.active]="viewMode==='annees'">
                <p>Année</p>
            </button>
            <button class="btn bouttons" rippleEffect (click)="openFlatpickr(); $event.preventDefault()"
                    style="color: rgba(19, 74, 211, 1);">
                <i data-feather="calendar"></i>
            </button>
        </div>
        <input type="text" #datePicker class="flatpickr-input" style="margin-top: 40px;"/>
    </div>
</div>

<div class="data-list mb-0 p-0" *ngIf="viewMode === 'jours'">
    <div class="data-list-wrapper">
        <div *ngFor="let day of weekDays"
             (click)="selectDay(day)"
             [class.selected]="day.dateString === selectedDay"
             [class.today]="day.isToday"
             class="day-item">
            {{ day.label }}
        </div>
    </div>
</div>

<div class="data-list mb-0 p-0" *ngIf="viewMode === 'mois'">
    <div class="data-list-wrapper">
        <div *ngFor="let month of months; let i=index"
             (click)="selectMonth(i)"
             [class.selected]="i === selectedMonthIndex"
             [class.today]="i === currentMonthIndex"
             class="month-item">
            {{ month }}
        </div>
    </div>
</div>

<div class="data-list mb-0 p-0" *ngIf="viewMode === 'annees'">
    <div class="data-list-wrapper">
        <div *ngFor="let year of years"
             (click)="selectYear(year)"
             [class.selected]="year === selectedYear"
             [class.today]="year === currentYear"
             class="year-item">
            {{ year }}
        </div>
    </div>
</div>

<!-- Même gabarit que shared.component : barre d’outils, tableau, pagination -->
<div class="d-flex" style="position: relative;">
    <div class="card-body row m-0 align-items-center flex-wrap" style="padding: 24px">
        <div class="input-group form-password-toggle d-flex" style="width: 300px;">
            <input
                    type="text"
                    class="form-control"
                    placeholder="Recherche par mot clé"
                    aria-label="Search..."
                    aria-describedby="basic-addon-search-pos"
                    [(ngModel)]="searchTerm"
                    (ngModelChange)="onSearch()"
            />
            <div class="input-group-append" style="margin-right: 10px;">
                <span class="input-group-text" id="basic-addon-search-pos" style="color: black;">
                    <i data-feather="search" [size]="20"></i>
                </span>
            </div>
        </div>
        <button type="button" class="btn btn-outline-primary btn-icon" (click)="toggleFilter()" rippleEffect STYLE="padding: 11px 11px !important;">
            <span data-feather="filter"></span>
        </button>

        <ng-select
                id="posWarehouseSelect"
                class="filter-ng-select pos-toolbar-ng-select flex-shrink-0"
                [items]="warehouseOptions"

                bindLabel="label"
                bindValue="id"
                [multiple]="true"
                [clearable]="true"
                [searchable]="true"
                placeholder="Tous les entrepôts"
                [(ngModel)]="selectedWarehouseIds"
                (change)="onWarehouseFilterChange()"
                [closeOnSelect]="false"
                appendTo="body">
        </ng-select>
        <ng-select
                id="posPaymentTypeSelect"
                class="filter-ng-select pos-toolbar-ng-select pos-toolbar-ng-select-payment flex-shrink-0"
                [items]="paymentTypeOptions"
                [clearable]="true"
                [searchable]="true"
                [multiple]="true"
                placeholder="Tous les types de paiement"
                [(ngModel)]="selectedPaymentTypes"
                (change)="onPaymentTypeFilterChange()"
                [closeOnSelect]="false"
                appendTo="body">
        </ng-select>

        <div class="active-filters-container d-flex flex-wrap align-items-center gap-2" style="margin-left: 12px;"
             *ngIf="getActiveFilters().length > 0">
            <div *ngFor="let filter of getActiveFilters(); trackBy: trackByFilterKey" class="filter-badge">
                <span class="filter-badge-label">{{ filter.label }}:</span>
                <span class="filter-badge-value">{{ filter.value }}</span>
                <button type="button" class="filter-badge-close"
                        (click)="removeFilter(filter.key, $event); $event.stopPropagation(); $event.preventDefault()"
                        aria-label="Supprimer le filtre">
                    <i data-feather="x" style="width: 12px; height: 12px;"></i>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="table-full-width">
    <div class="table-responsive" style="height: 700px">
        <table class="table table-hover pos-ticket-table">
            <thead class="custom-header">
            <tr>
                <th class="pos-ticket-table__th-check" style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 4%;">
                    <div class="pos-check form-check m-0">
                        <input #selectAllCheckbox class="form-check-input" type="checkbox"
                               [checked]="allPageSelected"
                               (change)="toggleSelectAllOnPage($any($event.target).checked)"
                               aria-label="Tout sélectionner sur la page"/>
                    </div>
                </th>
                <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 14%">NUMÉRO TICKET</th>
                <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 10%">DATE</th>
                <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 18%">CLIENT</th>
                <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 14%">ENTREPÔT</th>
                <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 14%">STATUT PAIEMENT</th>
                <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 12%">TYPE DE PAIEMENT</th>
                <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 12%">STATUT TICKET</th>
                <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 200px">ACTIONS</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of paginatedData; trackBy: trackByTicketId"
                class="pos-ticket-table__row-selectable"
                (click)="onTicketRowClick($event, item)">
                <td class="pos-ticket-table__td-check">
                    <div class="pos-check form-check m-0">
                        <input class="form-check-input" type="checkbox"
                               [checked]="isTicketSelected(item.id)"
                               (change)="toggleTicketSelection(item.id, $any($event.target).checked)"
                               [attr.aria-label]="'Sélectionner ' + item.numero"/>
                    </div>
                </td>
                <td>
                    <a class="ref d-flex align-items-center cursor-pointer hover-bg-light"
                       href="javascript:void(0)"
                       (click)="$event.preventDefault(); onViewTicket(item)">
                        {{ item.numero }}
                    </a>
                </td>
                <td style="font-size: 13px; color: rgba(47, 43, 61, 0.85);">{{ formatTicketDate(item.date) }}</td>
                <td>
                    <span class="size15" style="display: block;">{{ item.clientName }}</span>
                    <span class="phone-number">{{ item.clientPhone }}</span>
                </td>
                <td style="font-size: 13px;">{{ item.entrepot }}</td>
                <td>
                    <div class="status-badge-wrapper">
          <span [ngClass]="getPaymentBadgeNgClass(item)">
            {{ paymentStatusLabel(item.paymentStatus) }}
          </span>
                    </div>
                </td>
                <td style="font-size: 13px; color: rgba(47, 43, 61, 0.85);">{{ item.paymentType }}</td>
                <td>
                    <div class="status-badge-wrapper">
          <span [ngClass]="getTicketBadgeNgClass(item)">
            {{ ticketStatusLabel(item.ticketStatus) }}
          </span>
                    </div>
                </td>
                <td class="action-icons d-flex align-items-center">
                    <a class="me-2 action-icon" href="javascript:void(0)"
                       (click)="onViewTicket(item); $event.preventDefault()"
                       title="Voir"
                       style="color: rgba(47, 43, 61, 0.7); margin-right: 30px; width: 20px; height: auto">
                        <span data-feather="eye" [size]="20"></span>
                    </a>
                    <a class="me-2 action-icon" href="javascript:void(0)"
                       (click)="openConvertModal(item); $event.preventDefault()"
                       title="Convertir"
                       style="color: rgba(19, 74, 211, 1); margin-right: 30px; width: 20px; height: auto">
                        <span data-feather="repeat" [size]="20"></span>
                    </a>

                    <a class="me-2 action-icon" href="javascript:void(0)"
                       (click)="openDeleteConfirmModal(item); $event.preventDefault()"
                       title="Supprimer"
                       style="color: rgba(255, 76, 81, 1); margin-right: 30px; width: 20px; height: auto">
                        <span data-feather="trash-2" [size]="20"></span>
                    </a>
                </td>
            </tr>
            <tr *ngIf="paginatedData.length === 0">
                <td [attr.colspan]="ticketTableColspan" class="text-center" style="padding: 3rem;">
                    <div class="d-flex flex-column align-items-center justify-content-center">
                        <p class="mb-0" style="text-align: center; font-weight: 700; color: #6e6e6e;font-size: 15px">
                            Pas de données à afficher
                        </p>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</div>

<div class="">
    <div class="row d-flex pagination-bar">
        <div class="col-md-3 col-12">
            <div class="d-flex justify-content-between align-items-center">
                <label class="d-flex align-items-center" style="font-size: 15px; margin-left: 24px">
                    Afficher
                    <select class="form-control mx-25" [(ngModel)]="basicSelectedOption"
                            (ngModelChange)="updatePagination()">
                        <option [ngValue]="10">10</option>
                        <option [ngValue]="25">25</option>
                        <option [ngValue]="50">50</option>
                        <option [ngValue]="100">100</option>
                    </select>
                </label>
            </div>
        </div>
        <div class="col-md-9 col-12 pagination-col">
            <div class="pagination-row d-flex justify-content-end gap-2">
                <div class="page-box" [class.disabled]="currentPage === 1" (click)="currentPage > 1 && changePage(1)">«
                </div>
                <div class="page-box" [class.disabled]="currentPage === 1"
                     (click)="currentPage > 1 && changePage(currentPage - 1)">‹
                </div>
                <div *ngFor="let page of pages" class="page-box" [class.active]="page === currentPage"
                     (click)="changePage(page)">{{ page }}
                </div>
                <div class="page-box" [class.disabled]="currentPage === totalPages"
                     (click)="currentPage < totalPages && changePage(currentPage + 1)">›
                </div>
                <div class="page-box" [class.disabled]="currentPage === totalPages"
                     (click)="currentPage < totalPages && changePage(totalPages)">»
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Panneau latéral : détails ticket de caisse (gabarit modal-backdrop + modal-panel) -->
<div class="modal-backdrop" *ngIf="ticketDetail as vm" (click)="onClose()">
    <div class="modal-panel" (click)="onContentClick($event)">

        <div class="modal-header modal_head_title">
            <h3>détails ticket de caisse</h3>
            <button type="button" class="close-btn" (click)="onClose()">×</button>
        </div>

        <div class="modal-content">
            <!-- ================= 1. INFOS TICKET ================= -->
            <div class="section-card">
                <h4 class="section-title-blue">Informations du ticket</h4>

                <div class="row-item">
                    <span>Numéro de ticket</span><i class="fa-sharp fa-regular fa-circle-dollar"></i>
                    <strong>{{ vm.ticket.numero }}</strong>
                </div>
                <div class="row-item">
                    <span>Date</span>
                    <strong>{{ formatTicketDate(vm.ticket.date) }}</strong>
                </div>
                <div class="row-item">
                    <span>Entrepot</span>
                    <strong>{{ vm.ticket.entrepot }}</strong>
                </div>
                <div class="row-item">
                    <span>Statut ticket</span>
                    <span [ngClass]="getTicketBadgeNgClass(vm.ticket)">{{ ticketStatusLabel(vm.ticket.ticketStatus) }}</span>
                </div>
            </div>

            <!-- ================= 2. CLIENT & PAIEMENT ================= -->
            <div class="grid-2-col">
                <div class="info-card " style="padding: 24px">
                    <div class="card-header p-0">
                        <span class="card-title-blue">Info client</span>
                        <img src="/assets/images/logo/personne.svg" alt="client" class="card-icon">
                    </div>
                    <p class="client-name">{{ vm.ticket.clientName }}</p>
                    <p class="client-info">{{ vm.ticket.clientPhone }}</p>
                </div>

                <div class="info-card" style="padding: 24px">
                    <div class="card-header p-0">
                        <span class="card-title-blue">Info paiement</span>
                        <img src="/assets/images/logo/money9.svg" alt="paiement" class="card-icon">

                    </div>
                    <p class="client-name">{{ vm.ticket.paymentType }}</p>
                    <p class="client-info">Type de paiement</p>

                </div>
            </div>

            <!-- ================= 3. ARTICLES ================= -->
            <div class="section-card">
                <h4 class="section-title-blue">Articles</h4>
                <table class="custom-table">
                    <thead>
                    <tr>
                        <th>RÉFÉRENCE</th>
                        <th>CODE À BARRE</th>
                        <th>COULEUR / TAILLE</th>
                        <th class="text-right">PRIX UNIT</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let item of vm.lines; trackBy: trackByLineRef">
                        <td>{{ item.reference }}</td>
                        <td>{{ item.barcode }}</td>
                        <td>
                            {{ colorSizeMain(item) }}<br *ngIf="colorSizeSub(item)">
                            <small class="text-gray" *ngIf="colorSizeSub(item)">{{ colorSizeSub(item) }}</small>
                        </td>
                        <td class="text-right">{{ formatUnitPrice(item.unitPrice) }}</td>
                    </tr>

                    <tr *ngIf="vm.lines.length === 0">
                        <td>ere558r7e57</td>
                        <td>2225555658745</td>
                        <td>Bleu<br><small class="text-gray">XL</small></td>
                        <td class="text-right">125,000</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <!-- ================= 4. RÉSUMÉ FINANCIER ================= -->
            <div class="section-card">
                <h4 class="section-title-blue">Résumé financier</h4>

                <div class="row-item">
                    <span class="price-total-label">Prix total</span>
                    <strong class="price-total-value">{{ formatMoneyTnd(vm.totalPrice) }}</strong>
                </div>
                <div class="row-item">
                    <span>Montnat payé</span>
                    <strong>{{ formatMoneyTnd(vm.amountPaid) }}</strong>
                </div>
                <div class="row-item">
                    <span>Montnat payé</span>
                    <strong>{{ formatMoneyTnd(vm.amountPaid) }}</strong>
                </div>
                <div class="row-item">
                    <span>Statut paiement</span>
                    <span [ngClass]="getPaymentBadgeNgClass(vm.ticket)">{{ paymentStatusLabel(vm.ticket.paymentStatus) }}</span>
                </div>
            </div>

        </div>
    </div>
</div>

<app-convert-tick-caiss
        *ngIf="showConvertModal && ticketToConvert"
        [ticket]="ticketToConvert"
        (closed)="closeConvertModal()"
        (convert)="onConvertDocument($event)">
</app-convert-tick-caiss>

<!-- Confirmation suppression -->
<div class="pos-delete-confirm-backdrop"
     *ngIf="showDeleteConfirmModal && ticketPendingDelete as del"
     (click)="closeDeleteConfirmModal()"
     role="dialog"
     aria-modal="true"
     aria-labelledby="pos-delete-confirm-title">
    <div class="pos-delete-confirm-panel" (click)="$event.stopPropagation()">

        <div class="modal-header" style="background-color: transparent;border-bottom: 1px solid transparent;">
            <button type="button" class="close" click)="closeDeleteConfirmModal()" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="pos-delete-confirm-body">

            <h2 id="pos-delete-confirm-title" class="pos-delete-confirm-title">Supprimer le ticket ?</h2>
            <p class="pos-delete-confirm-text">
                Cette action est irréversible. Le ticket <strong>{{ del.numero }}</strong> sera définitivement supprimé.
            </p>
            <div class="pos-delete-confirm-actions">
                <button type="button"
                        class="btn pos-delete-confirm-btn-delete"
                        style="background: rgba(19, 74, 211, 1);color: rgba(255, 255, 255, 1)"
                        (click)="confirmDeleteTicket()">
                    Supprimer
                </button>
                <button type="button"
                        class="btn pos-delete-confirm-btn-cancel"
                        style="background: rgba(128, 131, 144, 0.16);color: rgba(128, 131, 144, 1)"
                        (click)="closeDeleteConfirmModal()">
                    Annuler
                </button>
            </div>
        </div>
    </div>
</div>

<div style="height: 110px"></div>
